import React, { Component, Fragment } from "react";

import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import Compose from "pages/communications/_components/Compose";
import { connect } from "react-redux";
import { bool, func } from "prop-types";

import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";

class NewMessage extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["communications"],
            titleKey: "communications.compose.message.new",
            goBackPath: "/communications",
        });
    };

    render() {
        const { isDesktop, embeddedInV3Shell } = this.props;
        const hideLegacyMobileHead = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;

        return (
            <Fragment>
                {!hideLegacyMobileHead && (
                    <Head
                        title="communications.compose.message.new"
                        closeLinkTo="/communications"
                        emptyRightOption
                        backLinkTo={!isDesktop ? "/communications" : null}
                        titleClassName={!isDesktop ? "header-mobile-title-background-blue" : null}
                        headerClassName={!isDesktop ? "blue-main-header-mobile" : null}
                    />
                )}
                <MainContainer>
                    <Compose />
                </MainContainer>
            </Fragment>
        );
    }
}

export default connect()(NewMessage);
